import update from "immutability-helper";

import {
  CE_SCREEN_OPEN,
  CE_SCREEN_UPDATE_STATE,
  CE_SCREEN_CLOSE,
} from "@js/actions/studio/screens.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_SCREEN_OPEN:
      return update(state, {
        screen: { $set: { name: action.name, state: action.state } },
      });
    case CE_SCREEN_UPDATE_STATE:
      return update(state, { screen: { state: { $merge: action.state } } });
    case CE_SCREEN_CLOSE:
      return update(state, { screen: { $set: null } });
    default:
      return state;
  }
};
